<div class="navigation-breadcrumb">
  <ng-container *ngFor="let level of levels; let last = last; trackBy: trackByLevelKey">
    <button type="button" class="breadcrumb-item" [ngClass]="level.key" [matMenuTriggerFor]="levelPanel.menu"
      [matTooltip]="level.labelKey
        ? (level.labelKey | translate) + (level.current?.name ? ': ' + level.current?.name : '')
        : level.current?.name" [disabled]="level.disabled" (menuOpened)="levelOpened.emit(level.key)"
      (menuClosed)="levelPanel.resetSearch()">
      <i *ngIf="level.icon" [class]="level.icon"></i>
      <span *ngIf="level.current?.indicator as indicator" class="breadcrumb-indicator"
        [ngClass]="'breadcrumb-indicator--' + indicator.kind" [matTooltip]="indicator.tooltip"></span>
      <span class="breadcrumb-text text-ellipsis">{{ level.current?.name }}</span>
      <i class="ri-arrow-down-s-line breadcrumb-caret"></i>
    </button>

    <span class="breadcrumb-separator" *ngIf="!last">/</span>

    <!-- The panel component renders nothing here (its host is hidden and the dropdown
         portals to the overlay on open); it must share the trigger's *ngFor scope so
         `#levelPanel` resolves. -->
    <ts-navigation-breadcrumb-menu #levelPanel [options]="level.options" [panelClass]="panelClass"
      [fallbackLevelKey]="level.key" [activeIds]="activeIds" (optionSelected)="optionSelected.emit($event)"
      (optionExpanded)="optionExpanded.emit($event)">
    </ts-navigation-breadcrumb-menu>
  </ng-container>
</div>
